var _style, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.9 80.3",
    style: {
      enableBackground: "new 0 0 92.9 80.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#35B0CB;}\n\t.st1{fill:none;stroke:#344154;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D2B859;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Programs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Programs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(12.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st0",
    points: "-9.9,-9.8 66.1,-9.8 66.1,-19.8 -9.9,-19.8  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    className: "st1",
    points: "-10.5,43.8 65.5,43.8 65.5,-19.5 56.1,-19.5 -10.5,-19.5  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-4",
    className: "st1",
    x1: -10.5,
    y1: -9.9,
    x2: 65.5,
    y2: -9.9
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "st2",
    points: "0.1,13.2 24.1,13.2 24.1,-0.8 0.1,-0.8  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    className: "st1",
    points: "65.4,43.8 -10.5,43.8 -10.5,30  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    className: "st1",
    points: "51.8,-19.5 65.4,-19.5 65.4,43.8  "
  })), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-7",
    className: "st1",
    x1: 0.1,
    y1: 18.7,
    x2: 24.1,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-8",
    className: "st1",
    x1: 0.1,
    y1: 24.7,
    x2: 24.1,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-9",
    className: "st1",
    x1: 0.1,
    y1: 30.7,
    x2: 24.1,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-7_1_",
    className: "st1",
    x1: 30.1,
    y1: 18.7,
    x2: 54.1,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-8_1_",
    className: "st1",
    x1: 30.1,
    y1: 24.7,
    x2: 54.1,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-9_1_",
    className: "st1",
    x1: 30.1,
    y1: 30.7,
    x2: 54.1,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-7_2_",
    className: "st1",
    x1: 30.1,
    y1: 12.7,
    x2: 54.1,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-7_3_",
    className: "st1",
    x1: 30.1,
    y1: 6.7,
    x2: 54.1,
    y2: 6.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-7_4_",
    className: "st1",
    x1: 30.1,
    y1: 0.7,
    x2: 54.1,
    y2: 0.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramsIcon);
export default __webpack_public_path__ + "static/media/Programs-Icon.b9271770be8e97f54516bd23b3368cdf.svg";
export { ForwardRef as ReactComponent };